/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
var a;!function(a){a[a.Realistic=0]="Realistic",a[a.Local=1]="Local",a[a.Mars=2]="Mars",a[a.None=3]="None"}(a||(a={}));export{a as AtmosphereType};
